import { b as __assign } from './tslib.es6-e24bb3a5.js';

var Device = function () {
  function Device() {
    var _this = this;

    this._ua = window.navigator.userAgent;
    this._agent = window.navigator.userAgent.toLowerCase();
    this._isIE11 = this._agent.indexOf('trident') > -1 && this._agent.indexOf('rv:11.0') > -1;

    this._getIosVersion = function () {
      var version = false;

      if (_this._agent.indexOf('like mac os x') > 0) {
        var reg = /os [\d._]+/gi;

        var v_info = _this._agent.match(reg);

        version = (v_info + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
        version = parseInt(version.split('.')[0]);
      }

      return version;
    };

    this._operaVersion = function () {
      var operaMatch = _this._agent.match(/opera.([\d.]+)/);

      var oprMatch = _this._agent.match(/opr\/([\d.]+)/);

      if (window.opera && operaMatch && operaMatch[1]) {
        return operaMatch[1];
      } else if (_this._agent.indexOf('opr') > 0 && oprMatch && oprMatch[1]) {
        return oprMatch[1];
      }

      return false;
    };

    this._ieVersion = function () {
      if (_this._isIE11) return '11';

      var msieMatch = _this._agent.match(/msie ([\d.]+)/);

      if (msieMatch) return msieMatch[1] || false;
      return window.document.documentMode;
    };

    this._edgeVersion = function () {
      var edgMatch = _this._agent.match(/edg\/([\d.]+)/);

      var edgeMatch = _this._agent.match(/edge\/([\d.]+)/);

      if (edgMatch) return edgMatch[1] || false;
      if (edgeMatch) return edgeMatch[1] || false;
      return false;
    };

    this._versionFilter = function (version) {
      if (typeof version === 'string') {
        var start = version.indexOf('.');

        if (start > 0) {
          var end = version.indexOf('.', start + 1);

          if (end !== -1) {
            return version.substr(0, end);
          }
        }

        return version;
      } else if (version) {
        return version;
      }

      return 0;
    };

    this.system = function () {
      var isAndroidPhone = /(?:Android)/.test(_this._ua);
      var isFireFox = /(?:Firefox)/.test(_this._ua);
      var isTablet = /(?:iPad|PlayBook)/.test(_this._ua) || isAndroidPhone && !/(?:Mobile)/.test(_this._ua) || isFireFox && /(?:Tablet)/.test(_this._ua);
      var isIOSTablet = /(?:iPad|PlayBook)/.test(_this._ua);
      var isAndroidTablet = isAndroidPhone && !/(?:Mobile)/.test(_this._ua) || isFireFox && /(?:Tablet)/.test(_this._ua);
      var isIPhone = /(?:iPhone)/.test(_this._ua) && !isTablet;
      var isIOS = isIPhone || isIOSTablet;
      var isAndroid = isAndroidPhone || isAndroidTablet;
      return {
        name: isAndroid ? 'Android' : isIOS ? 'IOS' : false,
        version: isAndroid ? _this._getAndroidVersion() : isIOS ? _this._getIosVersion() : false
      };
    };

    this.type = function () {
      var isWindowsPhone = /(?:Windows Phone)/.test(_this._ua);
      var isSymbian = /(?:SymbianOS)/.test(_this._ua) || isWindowsPhone;
      var isAndroid = /(?:Android)/.test(_this._ua);
      var isFireFox = /(?:Firefox)/.test(_this._ua);
      var isTablet = /(?:iPad|PlayBook)/.test(_this._ua) || isAndroid && !/(?:Mobile)/.test(_this._ua) || isFireFox && /(?:Tablet)/.test(_this._ua);
      var isPhone = /(?:iPhone)/.test(_this._ua) && !isTablet;
      var isPc = !isPhone && !isAndroid && !isSymbian;
      if (isTablet) return 'tablet';
      if (isPhone || isAndroid) return 'mobile';
      if (isPc) return 'computer';
      return false;
    };

    this.browser = function () {
      var isIE = _this._agent.indexOf('compatible') > -1 && _this._agent.indexOf('msie') > -1;
      var chrome = window.chrome || false;

      var firefoxMatch = _this._agent.match(/firefox\/([\d.]+)/);

      var chromeMatch = _this._agent.match(/chrome\/([\d.]+)/);

      var versionMatch = _this._agent.match(/version\/([\d.]+)/);

      var shell = function (System) {
        if (_this._agent.indexOf('maxthon') > 0) {
          var match = _this._agent.match(/maxthon\/([\d.]+)/);

          System.version = match && match[1] ? match[1] : System.version;
          return '傲游浏览器';
        }

        if (_this._agent.indexOf('qqbrowser') > 0) {
          var matchArray = _this._agent.match(/qqbrowser\/([\d.]+)/) || _this._agent.match(/qqbrowserlite\/([\d.]+)/);

          System.version = matchArray && matchArray[1] ? matchArray[1] : System.version;
          return _this._agent.match(/qqbrowser\/([\d.]+)/) ? 'QQ浏览器' : 'QQ浏览器 fro Mac';
        }

        if (_this._agent.indexOf('se 2.x') > 0) {
          return '搜狗浏览器';
        }

        if (chrome && System.name !== 'Opera') {
          var external_1 = window.external;
          var clientInfo = window.clientInformation;
          var clientLanguage = clientInfo.languages;

          if (external_1 && 'LiebaoGetVersion' in external_1) {
            return '猎豹浏览器';
          }

          if (_this._agent.indexOf('bidubrowser') > 0) {
            var matchbidu = _this._agent.match(/bidubrowser\/([\d.]+)/);

            var matchchrome = _this._agent.match(/chrome\/([\d.]+)/);

            if (matchbidu && matchbidu[1]) {
              System.version = matchbidu[1];
            } else if (matchchrome && matchchrome[1]) {
              System.version = matchchrome[1];
            }

            return '百度浏览器';
          }

          if ('track' in document.createElement('track') && typeof clientLanguage === 'undefined') {
            var storeKeyLen = Object.keys(chrome.webstore).length;
            return storeKeyLen > 1 ? '360极速浏览器' : '360安全浏览器';
          }

          return 'Chrome';
        }

        return System.name;
      };

      var System = {
        agent: _this._agent,
        isIE: isIE || _this._isIE11,
        isEdge: (_this._agent.indexOf('edge') > -1 || _this._agent.indexOf('edg') > -1) && !isIE,
        isGecko: _this._agent.indexOf('gecko') > 0 && _this._agent.indexOf('like gecko') < 0,
        isWebkit: _this._agent.indexOf('webkit') > 0,
        width: window.innerWidth,
        height: window.innerHeight,
        dpr: window.devicePixelRatio
      };
      System.name = System.isIE ? 'IE' : System.isEdge ? 'Edge' : window.opera || _this._agent.indexOf('opr') > 0 ? 'Opera' : _this._agent.indexOf('safari') > -1 && _this._agent.indexOf('chrome') === -1 ? 'Safari' : _this._agent.indexOf('chrome') > 0 ? 'Chrome' : _this._agent.indexOf('firefox') > 0 ? 'Firefox' : false;
      System.version = System.name === 'IE' ? _this._ieVersion() : System.name === 'Edge' ? _this._edgeVersion() : System.name === 'Firefox' ? firefoxMatch ? firefoxMatch[1] : false : System.name === 'Chrome' ? chromeMatch ? chromeMatch[1] : false : System.name === 'Opera' ? _this._operaVersion() : System.name === 'Safari' ? versionMatch ? versionMatch[1] : false : false;
      System.shellName = shell(System);
      System.version = _this._versionFilter(System.version);
      return __assign(__assign({}, System), {
        name: System.name === false ? System.shellName : System.name
      });
    };

    this.userAgent = function () {
      return _this._ua;
    };
  }

  Device.prototype._getAndroidVersion = function () {
    var version = false;

    if (this._agent.indexOf('android') > 0) {
      var reg = /android [\d._]+/gi;

      var v_info = this._agent.match(reg);

      version = (v_info + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
      version = parseInt(version.split('.')[0]);
    }

    return version;
  };

  return Device;
}();

var index = new Device();

export default index;
